import * as errorTypes from 'config/errorTypes';

export const BASE_API_ERROR = {
    [errorTypes.NOT_FOUND]: r => r.httpStatus === 404,
    [errorTypes.API_ERROR]: r => r.httpStatus !== 200
};

export const CREATE_GIDP_ACCOUNT_ERROR = {
    [errorTypes.GIDP_ACCOUNT_ALREADY_EXISTS]: r =>
        r.httpStatus === 400 &&
        r?.payload?.message === 'The email address is already in use by another account.',
    [errorTypes.PASSWORD_TOO_SHORT]: r =>
        r.httpStatus === 422 &&
        r?.payload?.message === 'validation failed' &&
        r?.payload?.data?.password[0] === 'The password must be at least 12 characters.',
    [errorTypes.ROLE_NOT_ALLOW]: r =>
        r.httpStatus === 400 && r?.payload?.message === 'role not allow',
    [errorTypes.CREATE_GIDP_ACCOUNT_FAILED]: r => r.httpStatus >= 400,
    ...BASE_API_ERROR
};

export const UPDATE_GIDP_ACCOUNT_ERROR = {
    [errorTypes.GIDP_ACCOUNT_ALREADY_EXISTS]: r =>
        r.httpStatus === 400 && r?.payload?.message === 'email already exists',

    [errorTypes.PASSWORD_TOO_SHORT]: r =>
        r.httpStatus === 422 &&
        r?.payload?.message === 'validation failed' &&
        r?.payload?.data?.password[0] === 'The password must be at least 12 characters.',
    [errorTypes.ROLE_NOT_ALLOW]: r =>
        r.httpStatus === 400 && r?.payload?.message === 'role not allow',
    [errorTypes.UPDATE_GIDP_ACCOUNT_FAILED]: r => r.httpStatus >= 400,
    ...BASE_API_ERROR
};

export const BATCH_CREATE_ACCOUNTS_ERROR = {
    [errorTypes.PASSWORD_TOO_SHORT]: r =>
        r.httpStatus === 400 &&
        r?.payload?.message.includes('password must be a string with at least 12 characters'),
    [errorTypes.BATCH_CREATE_ACCOUNTS_EMPTY_VALUE]: r =>
        r.httpStatus === 400 && r?.payload?.message?.includes('excel has empty value on row'),
    [errorTypes.BATCH_CREATE_ACCOUNTS_INVALID_EMAIL]: r =>
        r.httpStatus === 400 && r?.payload?.message?.includes('contains invalid email format'),
    [errorTypes.BATCH_CREATE_ACCOUNTS_DUPLICATE_EMAIL]: r =>
        r.httpStatus === 400 && r?.payload?.message?.includes('contains duplicate email'),
    [errorTypes.BATCH_CREATE_ACCOUNTS_EXCEL_FORMAT_ERROR]: r =>
        r.httpStatus === 400 && r?.payload?.message === 'excel format error',
    [errorTypes.BATCH_CREATE_ACCOUNTS_FAILED]: r => r.httpStatus >= 400,
    ...BASE_API_ERROR
};
